// covered-by: frontends/carrie/src/ask-v2/home/__tests__/AskV2Home.test.tsx
import { Button, TextArea } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { type AskV2TransportApi } from "./useAskV2Transport";

type SummonBarProps = {
  transport: AskV2TransportApi;
  onDismiss: () => void;
  dismissing?: boolean;
};

export function AskV2SummonBar({
  transport,
  onDismiss,
  dismissing = false,
}: SummonBarProps) {
  const { t } = useTranslation("ui");
  const canSend =
    Boolean(transport.composer.trim()) &&
    !transport.sending &&
    !transport.inFlight;

  return (
    <form
      data-testid="ask-v2-summon-bar"
      className="flex w-full max-w-2xl flex-col gap-2"
      onSubmit={(event) => {
        event.preventDefault();
        void transport.send();
      }}
    >
      <TextArea
        data-testid="ask-v2-composer"
        placeholder={t("askV2.transport.placeholder")}
        value={transport.composer}
        onChange={(event) => transport.setComposer(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            if (canSend) void transport.send();
          }
        }}
      />
      <div className="flex items-center justify-between gap-2">
        <Button
          type="button"
          variant="ghost"
          data-testid="ask-v2-dismiss"
          onClick={onDismiss}
          disabled={dismissing}
        >
          {t("askV2.home.dismiss")}
        </Button>
        {transport.inFlight || transport.sending ? (
          <Button
            type="button"
            color="red"
            data-testid="ask-v2-stop"
            onClick={() => {
              void transport.abort();
            }}
            disabled={transport.aborting}
          >
            {t("askV2.transport.stop")}
          </Button>
        ) : (
          <Button type="submit" data-testid="ask-v2-ask" disabled={!canSend}>
            {t("askV2.transport.ask")}
          </Button>
        )}
      </div>
    </form>
  );
}
